export class SnsFloat {
  constructor() {
    this.root = document.querySelector('.l-sns-float');
    if (!this.root) {
      return;
    }

    this.button = this.root.querySelector('.l-sns-float__toggle');
    this.links = Array.from(this.root.querySelectorAll('.l-sns-float__sns-link'));

    if (!this.button) {
      return;
    }

    this.isOpen = false;
    this.onToggleClick = this.handleToggleClick.bind(this);
    this.onDocumentClick = this.handleDocumentClick.bind(this);
    this.onDocumentKeydown = this.handleDocumentKeydown.bind(this);

    this.init();
  }

  init() {
    this.button.addEventListener('click', this.onToggleClick);
    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onDocumentKeydown);
    this.sync();
  }

  destroy() {
    this.button.removeEventListener('click', this.onToggleClick);
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onDocumentKeydown);
  }

  handleToggleClick(event) {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    this.sync();
  }

  handleDocumentClick(event) {
    if (!this.isOpen || this.root.contains(event.target)) {
      return;
    }

    this.isOpen = false;
    this.sync();
  }

  handleDocumentKeydown(event) {
    if (event.key !== 'Escape' || !this.isOpen) {
      return;
    }

    this.isOpen = false;
    this.sync();
    this.button.focus();
  }

  sync() {
    this.root.classList.toggle('is-open', this.isOpen);
    this.button.setAttribute('aria-expanded', String(this.isOpen));
    this.button.setAttribute('aria-label', this.isOpen ? 'SNSメニューを閉じる' : 'SNSメニューを開く');
    this.links.forEach((link) => {
      link.tabIndex = this.isOpen ? 0 : -1;
    });
  }
}
